import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu--home-index--area-navigation', class extends Controller {
  static targets = ['prefectureList']

  connect() {
    // 初期化: すべての都道府県リストを非表示
    this.prefectureListTargets.forEach(list => {
      list.style.display = 'none'
    })

    // 背景クリックでリストを閉じるためのイベントリスナーを追加
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener('click', this.handleOutsideClick)
  }

  disconnect() {
    // コンポーネントが破棄される時にイベントリスナーを削除
    document.removeEventListener('click', this.handleOutsideClick)
  }

  toggleRegion(event) {
    const button = event.currentTarget

    // クリックされたボタンの次の要素（都道府県リスト）を取得
    const prefectureList = button.nextElementSibling

    if (!prefectureList) {
      console.error('Prefecture list not found')
      return
    }

    // 他の都道府県リストを閉じる
    this.prefectureListTargets.forEach(list => {
      if (list !== prefectureList) {
        list.style.display = 'none'
        // 他のボタンのアクティブ状態を解除
        const otherButton = list.previousElementSibling
        if (otherButton) {
          otherButton.classList.remove('is-active')
        }
      }
    })

    // クリックされた都道府県リストをトグル
    if (prefectureList.style.display === 'none') {
      prefectureList.style.display = 'block'
      button.classList.add('is-active')
    } else {
      prefectureList.style.display = 'none'
      button.classList.remove('is-active')
    }
  }

  handleOutsideClick(event) {
    // クリックされた要素が地域ボタンまたは都道府県リスト内かどうかを確認
    const isRegionButton = event.target.closest('.area-navigation__region-button')
    const isPrefectureList = event.target.closest('.area-navigation__prefecture-list')

    // 地域ボタンまたは都道府県リスト内のクリックでなければリストを閉じる
    if (!isRegionButton && !isPrefectureList) {
      this.closeAllLists()
    }
  }

  closeAllLists() {
    this.prefectureListTargets.forEach(list => {
      list.style.display = 'none'
      // ボタンのアクティブ状態を解除
      const button = list.previousElementSibling
      if (button) {
        button.classList.remove('is-active')
      }
    })
  }
})
